import React from "react";
import Helmet from "react-helmet";

class ManageCookies extends React.Component {

    componentDidUpdate(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    render() {
		const dtm_deviceCheck = /Mobile/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
		const dataLayer = {
			"formName": "",
			"formStatus": "",
			"formisSubmitted": false,
			"deviceType": dtm_deviceCheck,
			"siteBusinessUnit": "Tutuwa",
			"siteErrorCode": "",
			"siteLanguage": "English",
			"siteCountry": "South Africa",
			"websiteName": "Tutuwa Foundation",
			"websiteNameCode": "TT",
			"pageCategory": "Manage Cookies",
			"pageName": "Manage Cookies",					
			"pageSubSection1": "Manage Cookies",
			"pageSubSection2": "",
			"pageSubSection3": "",
			"pageSubSection4": ""
		};
        return (

            <div className="terms-and-conditions">

                <Helmet>
                    <title>The Standard Bank Tutuwa Community Foundation: Manage Cookies </title>
                    <meta name="title" content="The Standard Bank Tutuwa Community Foundation: Manage Cookies "/>
                    <meta name="description" content="We aim to help young South Africans reach their full potential and make an active contribution to their community."/>
                    <meta name="keywords" content="Standard bank; tutuwa foundation; South African youth; investing in South Africa’s youth; social impact initiatives; economic development; investing in social impact bonds; impact investing; thought leadership; economic growth and development; industrial development; department of trade, industry and competition; youth empowerment; black economic empowerment"/>
                    <meta name="robots" content="index, follow"/>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
                    <meta name="language" content="English"/>
					<script type="text/javascript" language="javascript">{`
						var dataLayer = ${JSON.stringify(dataLayer)};
					`}</script>
					<script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-4d4e0baaa532-development.min.js" async></script>
					{/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-0ec4707af30e-staging.min.js" async></script>
					<script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-e88652abdf04.min.js" async></script> */}
                </Helmet>
				
				<div className="content-wrapper">

					<div className="content">

						<div id="Top"></div>

						<h2>Manage your cookie settings.</h2>

						<div style={{width: "100%", marginBottom: "15px"}}><button id="ot-sdk-btn" class="ot-sdk-show-settings">Manage Cookies</button></div>

						<p>
							When you visit this website, we may store or retrieve information on your browser, mostly in the form of cookies. Cookies contain specific information related to your use of our website or app. We use cookies to give you a better experience online. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not directly identify you, but can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. There are some cookies that are essential to the functioning of the website and may not be disabled. Click on the 'Manage Cookies' button below to change your settings.
						</p>

						<p>
							<strong>Optional cookies</strong><br></br><br></br>
							Session cookies - These cookies are temporary and only exist while you browse our website. As soon as you close your browser or move to a different website, they are removed. They allow our website to link your actions during a browser session.
							<br></br><br></br>
							Persistent cookies - These are permanent cookies that are stored on your device until they reach a set expiry date or until you delete them. They remember your preferences or actions across our site (or in some cases across different websites). We may use them for various reasons, such as remembering your preferences and choices when using our site, or to display only relevant advertising messages to you.
							<br></br><br></br>
							First-party cookies - We own and create these cookies. Third-party cookies - These cookies are owned and created by another company that provides a service to us, such as social media sharing, website analytics or content marketing.
						</p>

						<p>
							<strong>How to disable cookies</strong><br></br><br></br>
							You can stop your browser from accepting cookies by changing the settings on your web browser. Please note that restricting cookies may impact the functionality of our websites. We recommend that you allow cookies, to enable the efficient and proper functioning of the website. Explore the settings and options on your browser to disable or enable them, or visit https://www.aboutcookies.org for detailed information about managing cookies on different browsers.
						</p>

					</div>					

				</div>

            </div>

		);
		
	}
	
}

export default ManageCookies;
